import React from 'react';
import { isNil } from 'lodash-es';
import { ValidationError } from 'pages/upload.page/publish-video/fragments';

export const Input = ({ input, label, placeholder, type, meta: { touched, error } }) => (
  <div className="form-group">
    {!isNil(label) && <label className="label">{label}</label>}
    <input
      {...input}
      type={type}
      className={error ? 'form-control validation-error-border' : 'form-control'}
      aria-describedby={label}
      placeholder={placeholder}
      autoComplete="off"
    />
    <ValidationError error={error} />
  </div>
);
